import * as React from "react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";
import type { SelectOption } from "./types";

interface ResponsiveCommandMultiSelectTriggerProps {
  selectedOptions: SelectOption[];
  placeholder: string;
  disabled: boolean;
  className?: string;
  triggerRef: React.RefObject<HTMLButtonElement>;
  onClick?: (e: React.MouseEvent) => void;
  "aria-expanded"?: boolean;
  "aria-haspopup"?: "listbox" | "dialog";
}

export function ResponsiveCommandMultiSelectTrigger({
  selectedOptions,
  placeholder,
  disabled,
  className,
  triggerRef,
  onClick,
  "aria-expanded": ariaExpanded,
  "aria-haspopup": ariaHaspopup,
}: ResponsiveCommandMultiSelectTriggerProps) {
  return (
    <Button
      variant="outline"
      className={cn("justify-between w-full", className)}
      disabled={disabled}
      ref={triggerRef}
      onClick={onClick}
      aria-expanded={ariaExpanded}
      aria-haspopup={ariaHaspopup}
    >
      {selectedOptions.length > 0 ? (
        <div className="flex items-center gap-1 truncate">
          {selectedOptions.slice(0, 2).map((opt) => (
            <Badge key={opt.value} variant="secondary" className="max-w-[140px] truncate">
              {opt.label}
            </Badge>
          ))}
          {selectedOptions.length > 2 && (
            <span className="text-xs text-muted-foreground">
              +{selectedOptions.length - 2} more
            </span>
          )}
        </div>
      ) : (
        <span className="text-muted-foreground">{placeholder}</span>
      )}
      <ChevronDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
    </Button>
  );
}
